import React, { Component } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {Formik, Field, Form} from 'formik';
import HomeNav from "components/Navbars/HomeNav.js";
import queryString from 'query-string';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {Modal} from "react-bootstrap";
import Pagination from 'react-bootstrap/Pagination';

// reactstrap components
import {
  Container,
  Card,
  CardBody,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  UncontrolledCollapse,
  InputGroup
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import {
  notifyDonorsAction,
  addVolunteerDonorAction,
  deleteVolunteerDonorAction,
  addActualDonorAction
} from 'actions/donorActions';

import { 
        saveMatchingDonorAction,
        patientFetchAction, 
        patientMatchDonorsAction,
        patientMatchDonorPhoneAction, 
        updatePatientAction  } 
from 'actions/patientActions';
import { fetchLocalityAction } from 'actions/localityActions';

const moment = require('moment');

class PatientRequestDetails extends Component {
  constructor(props) {
    super(props);
    this.state ={
      firstFocus: '',
      lastFocus: '',
      patientDetails: undefined,
      show: false,
      showNotes: false,
      showActualDonor: false,
      actualDonorDate: '',
      actualDonorId: '',
      notes: '',
      notesModifiedBy: '',
      matchingDonorIndex: -1,
      matchingDonorId: '',
      modalOKEnabled: false,
      resultSize: 5,
      reqId: '',
      country: '',
      stateLocation: '',
      localityFilter: 'All',
      districtFilter: '',
      nameFilter: '',
      status: '',
      updateStatusClicked: false,
      phone: ''
    }
    this.handleNotifyDonors = this.handleNotifyDonors.bind(this);
    this.handleNotifyDonor = this.handleNotifyDonor.bind(this); 
    this.handleDonorClick = this.handleDonorClick.bind(this);   
    this.addVolunteerDonor = this.addVolunteerDonor.bind(this);
    this.deleteVolunteerDonor = this.deleteVolunteerDonor.bind(this);
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.setShowNotes = this.setShowNotes.bind(this);
    this.handleShowNotes = this.handleShowNotes.bind(this);
    this.handleSaveNotes = this.handleSaveNotes.bind(this);
    this.handleCloseNotes = this.handleCloseNotes.bind(this);
    this.handleChangeNotes = this.handleChangeNotes.bind(this);
    this.handleAddActualDonor = this.handleAddActualDonor.bind(this);
    this.handleShowActualDonor = this.handleShowActualDonor.bind(this);
    this.handleCloseActualDonor = this.handleCloseActualDonor.bind(this);
    this.handleChangeActualDonorDate = this.handleChangeActualDonorDate.bind(this);
    this.saveActualDonor = this.saveActualDonor.bind(this);
    this.populateStatus = this.populateStatus.bind(this);

    this.constructPaginationLinks = this.constructPaginationLinks.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.sizeChanged = this.sizeChanged.bind(this);
    this.localityFilterChanged = this.localityFilterChanged.bind(this);
    this.districtFilterChanged = this.districtFilterChanged.bind(this);
    this.filterByName = this.filterByName.bind(this);
  }

  componentWillMount() {
    document.title = 'Liquid Love Request details';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/requests';
    }

    let params = queryString.parse(this.props.location.search);

    this.state.reqId = params.reqId;
    this.state.country = params.country;
    this.state.stateLocation = params.state;
    this.state.districtFilter = params.district;
    this.state.status = params.status;
    if(params.locality !== undefined && params.locality !== '')
      this.state.localityFilter = params.locality;

    if(params.name !== undefined && params.name !== '')
      this.state.nameFilter = params.name;

    const matchDonorsPayload = {
      reqId: this.state.reqId,
      token: this.props.response.login.userToken,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
    };
    const localityPayload = {
      country: params.country,
      stateLocation: this.state.stateLocation,
      district: this.state.districtFilter,
      token: this.props.response.login.userToken,
    };

    const fetchPayload = {
      reqId: this.state.reqId,
      token: this.props.response.login.userToken 
    };  
    
    if (this.state.status && (this.state.status === 'Open' ||
        this.state.status === 'Fulfilled-Closed' ||
        this.state.status === 'Cancelled-Closed' ||
        this.state.status === 'Partially Fulfilled-Closed' ||
        this.state.status === 'Unknown Donor-Closed' ||
        this.state.status === 'Not Fulfilled-Closed')) {  
          this.props.dispatch(patientFetchAction(fetchPayload));
    }
    else{
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
      this.props.dispatch(fetchLocalityAction(localityPayload));
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("sidebar-collapse");

    if(this.props.response.patient !== 'undefined' && 
      (this.props.response.donor.redirectUrl === undefined ||
      this.props.response.donor.redirectUrl === ''))
        delete this.props.response.patient;
        
    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;
    
    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    this.props.response.donor.noServiceResponse = false;
    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  }

  handleDonorClick(donorPhone) {
    this.props.response.donor.redirectUrl = '/liquidlove/patient-details?reqId=' + this.state.reqId + '&country=' + this.state.country + '&state=' + this.state.stateLocation + '&district=' + this.state.districtFilter + '&status=' + this.state.status + '&locality=' + this.state.localityFilter + '&name=' + this.state.nameFilter
    this.props.navigate('/liquidlove/donor?accessMode=admin&donorPhone=' + donorPhone);
  }

  handleVerifyClick() {
    this.props.navigate('/liquidlove/patient?accessMode=admin&reqId=' + this.state.reqId);
  }

  handleUpdateRequestClick() {
    this.props.navigate('/liquidlove/patient?accessMode=admin&reqId=' + this.state.reqId);
  }

  handleBackClick() {
    this.props.navigate('/liquidlove/requests');    
  }

  handleNotifyDonors(currentPage){
    const notifyPayload = {
      requestId: this.props.response.patient.id,
      matchingDonors: this.props.response.patient.matchingDonors.content,
      pageNum: currentPage,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    };

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;      
    
    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';      
    
    if (this.props.response.login.isSignedIn)
      this.props.dispatch(notifyDonorsAction(notifyPayload));
  }

  handleNotifyDonor(donor, currentPage){
    let donors = [];
    donors.push(donor);
    const notifyPayload = {
      requestId: this.props.response.patient.id,
      matchingDonors: donors,
      pageNum: currentPage,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    };

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;      

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';

    if (this.props.response.login.isSignedIn)      
      this.props.dispatch(notifyDonorsAction(notifyPayload));
  }

  addVolunteerDonor(volunteerDonorId){
    const volunteerPayload = {
      requestId: this.props.response.patient.id,
      volunteerDonor: volunteerDonorId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    };
    
    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;
    
    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
    
    if (this.props.response.login.isSignedIn){
      this.handleShow();
      this.props.dispatch(addVolunteerDonorAction(volunteerPayload));
    }
  }

  deleteVolunteerDonor(volunteerDonorId){
    const volunteerPayload = {
      requestId: this.props.response.patient.id,
      volunteerDonor: volunteerDonorId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    };

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {
      this.handleShow();
      this.props.dispatch(deleteVolunteerDonorAction(volunteerPayload));
    }
  }

  handleViewRequestsClick(){
    this.props.navigate('/liquidlove/requests');
  }

  setShowNotes(bool) {
    this.setState({ showNotes: bool });
  }

  handleCloseNotes = () => { 
    this.setShowNotes(false); 
  };
  
  handleShowNotes = (idx, donorId) => { 
    let index = this.props.response.patient.matchingDonorsDetails.findIndex((el) => el.donorId === donorId);
    this.setState({ 
      //notes: this.props.response.patient.matchingDonorsDetails[index] ? this.props.response.patient.matchingDonorsDetails[index].notes : '',
      notes: "",
      notesModifiedBy: this.props.response.patient.matchingDonorsDetails[index] ? this.props.response.patient.matchingDonorsDetails[index].modifiedBy : 'None',
      matchingDonorIndex: idx,
      matchingDonorId: donorId
     });
    this.setShowNotes(true); 
  };
  
  populateStatus(donorId){
    let index = this.props.response.patient.matchingDonorsDetails.findIndex((el) => el.donorId === donorId);
    if(this.props.response.patient.matchingDonorsDetails[index])    
      switch(this.props.response.patient.matchingDonorsDetails[index].status) {        
        case 'Notification Initiated':
          return 0
        case 'sent sms,sent email':
          return 1
        case 'sms failed,sent email':
          return 2
        case 'sms failed,email failed':
          return 3
        case 'sent sms,email failed':    	
          return 4
        default:
          return -1;
      }
      
  }

  handleChangeNotes = (e) => this.setState({notes: e.target.value})

  handleSaveNotes = () => { 
    let index = this.props.response.patient.matchingDonorsDetails.findIndex((el) => el.donorId === this.state.matchingDonorId);
    let status = '';
    let id = undefined;
    /*
    if(index >= 0){
      status = this.props.response.patient.matchingDonorsDetails[index].status
      id = this.props.response.patient.matchingDonorsDetails[index].id
    };*/
    const matchingDonor = {
      index: index,
      donorId: this.state.matchingDonorId,
      callNotes: this.state.notes,
    };
    const saveMatchingDonorPayload = {
      matchingDonor: matchingDonor,
      token: this.props.response.login.userToken
    };

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
      
    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;      
    
    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if(this.props.response.login.isSignedIn)
      this.props.dispatch(saveMatchingDonorAction(saveMatchingDonorPayload));
    this.handleCloseNotes();
  }

  handleChangePhone = (e) => this.setState({phone: e.target.value})

  matchingDonorByPhone = (e) => { 
    const payload = { 
      reqId: this.props.response.patient.id,
      donorPhone: this.state.phone,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      token: this.props.response.login.userToken
    }

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';  

    this.handleShow();
    this.state.modalOKEnabled = false;
    
    if (this.props.response.login.isSignedIn)
      this.props.dispatch(patientMatchDonorPhoneAction(payload));
  }

  setShow(bool) {
    this.setState({ show: bool });
  }
  
  handleClose = () => { 
    this.setShow(false); 
    if(this.state.updateStatusClicked){
      this.state.updateStatusClicked = false;
      this.props.navigate('/liquidlove/requests');
    }
  };
  
  handleShow = () => { this.setShow(true) };

  handleChangeActualDonorDate = (e) => this.setState({actualDonorDate: moment(e.target.value, 'YYYY-MM-DD').format('DD/MM/YYYY')})
  
  setShowActualDonor(bool) {
    this.setState({ showActualDonor: bool });
  }

  handleShowActualDonor = () => { 
    this.setShowActualDonor(true); 
  };

  handleCloseActualDonor = () => { 
    this.setShowActualDonor(false); 
  };

  handleAddActualDonor(actualDonorId){
    this.handleShowActualDonor();
    this.state.actualDonorId = actualDonorId;
  }

  saveActualDonor = () => { 
    this.handleCloseActualDonor();
    const addActualDonorPayload = {
      requestId: this.props.response.patient.id,
      actualDonor: this.state.actualDonorId,
      actualDonorDate: this.state.actualDonorDate,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    };
    
    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.handleShow();
    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
    if(this.props.response.login.isSignedIn)
      this.props.dispatch(addActualDonorAction(addActualDonorPayload));
  }

  constructPaginationLinks(totalPages,currentPage) {
    let items = [];
    if (totalPages === 1 || totalPages === 0) {
      return items;
    }
    for (let number = 0; number < totalPages; number++) {
      let index = number + 1;

      items.push(
        <Pagination.Item key={index} active={index === (currentPage) + 1}>
          {index}
        </Pagination.Item>
      );
    }
    return items;
  }

  handleChangeName = (e) => this.setState({nameFilter: e.target.value})

  filterByName(e){
    
    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;
  
    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
    }
  }

  pageChanged(e) {
    let index = e.target.text;

    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: parseInt(index -1),
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;
    
    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;      
    
    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;
  
    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
    }
  }

  sizeChanged(e){
    this.state.resultSize = parseInt(e.target.text);

    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;
  
    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
    }
  }

  localityFilterChanged(e){
    this.state.localityFilter = e.target.value;
    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;

    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
    }
  }

  localityFilterClicked(e){
    this.state.localityFilter = e.target.text;
    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }

    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
    }
  }

  districtFilterChanged(e){
    this.state.districtFilter = e.target.text;
    this.state.localityFilter = 'All'
    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: 0,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }
    const localityPayload = {
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      district: this.state.districtFilter,
      token: this.props.response.login.userToken,
    };
    
    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
      this.props.dispatch(fetchLocalityAction(localityPayload));
    }
  }

  handleRefresh(currentPage){
    const matchDonorsPayload = { 
      reqId: this.state.reqId,
      pageNum: currentPage,
      size: this.state.resultSize,
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      localityFilter: this.state.localityFilter,
      districtFilter: this.state.districtFilter,
      nameFilter: this.state.nameFilter,
      token: this.props.response.login.userToken
    }
        
    if(this.props.response.donor.addVolunteerDonor !== 'undefined')
      delete this.props.response.donor.addVolunteerDonor;

    if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
      delete this.props.response.donor.deleteVolunteerDonor;

    if(this.props.response.donor.response !== 'undefined')
      delete this.props.response.donor.response;
    
    if(this.props.response.patient.matchDonor !== 'undefined')
      delete this.props.response.patient.matchDonor;

    if(this.props.response.donor.addActualDonor !== 'undefined')
      delete this.props.response.donor.addActualDonor;

    if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
      delete this.props.response.patient.saveMatchingDonorResponse;

    this.state.actualDonorId = '';
    this.state.actualDonorDate = '';
  
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(patientMatchDonorsAction(matchDonorsPayload));
    }
  }

  onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }
  
  render() {  
    let message = '';
    let totalPages = 0;
    let currentPage = 0;
    let i=-1;
        
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }    
    
    this.state.reqId = this.props.response.patient.id;
    this.state.country = this.props.response.patient.country;
    this.state.stateLocation = this.props.response.patient.stateLocation;

    if(this.props.response.patient === undefined || this.props.response.patient.noServiceResponse){
      this.state.modalOKEnabled = true;
      message = 'Sairam! Sorry. We are not able to process your request. Please try later.'
    }
    else if(this.props.response.patient.response && this.props.response.patient.response.hasOwnProperty('error')){
      this.state.modalOKEnabled = true;  
      if(this.props.response.patient.response.status === 401)
        message = 'Your session has expired. Please login again'
      else if(this.props.response.patient.response.status === 400){
          message = this.props.response.patient.response.message;
        }
      else
        message = 'Sairam! Sorry. We are not able to process your request.'
    }
    else if(this.props.response.patient.systemRemarks && this.props.response.patient.systemRemarks !== ''){
      this.state.modalOKEnabled = true;
      message = this.props.response.patient.systemRemarks;
    }
      
    
    if(this.props.response.donor.hasOwnProperty('response') &&
    this.props.response.donor.response !== undefined){
      this.state.modalOKEnabled = true;
      if(this.props.response.donor.response.hasOwnProperty('error')){
        if(this.props.response.donor.response.status === 401){
          message = 'Your session has expired. Please login again'
        }
        else if(this.props.response.donor.response.status === 400){
          message = this.props.response.donor.response.message;
        }
        else
          message = 'Sairam! Sorry. We are not able to process your request.'
      }
      else{
        this.props.response.patient = this.props.response.donor.response.patient;
        message = this.props.response.donor.response.notifyDonorStatus  
      }
    }
    else if(this.props.response.donor.hasOwnProperty('addVolunteerDonor') &&
    this.props.response.donor.addVolunteerDonor !== undefined){
      this.state.modalOKEnabled = true;
      if(this.props.response.donor.addVolunteerDonor.patient)
        this.props.response.patient = this.props.response.donor.addVolunteerDonor.patient;
      message = this.props.response.donor.addVolunteerDonor.volunteerDonorStatus;
    }
    else if(this.props.response.donor.hasOwnProperty('deleteVolunteerDonor') &&
    this.props.response.donor.deleteVolunteerDonor !== undefined){
      this.state.modalOKEnabled = true;
      this.props.response.patient = this.props.response.donor.deleteVolunteerDonor.patient;
      message = this.props.response.donor.deleteVolunteerDonor.volunteerDonorStatus;
    }
    else if(this.props.response.donor.hasOwnProperty('addActualDonor') &&
    this.props.response.donor.addActualDonor !== undefined){
      this.state.modalOKEnabled = true;
      this.props.response.patient = this.props.response.donor.addActualDonor.patient;
      message = this.props.response.donor.addActualDonor.message;
    }
    else if(this.props.response.patient.hasOwnProperty('matchDonorPhone') &&
    this.props.response.patient.matchDonorPhone !== undefined){
      this.state.modalOKEnabled = true;
      message = this.props.response.patient.matchDonorPhone.status;
      this.props.response.patient = this.props.response.patient.matchDonorPhone.patient;
    }
    else if(this.props.response.patient.hasOwnProperty('saveMatchingDonorResponse') &&
    this.props.response.patient.saveMatchingDonorResponse !== 'undefined'){
      this.state.modalOKEnabled = true;
      message = this.props.response.patient.saveMatchingDonorResponse.message;
      if(this.props.response.patient.saveMatchingDonorResponse.status === 'SUCCESS'){
        //index of matching donor to be updated in patient object
        i = this.props.response.patient.saveMatchingDonorResponse.index;
        let tempMatchingDonors = this.props.response.patient.matchingDonors;
        tempMatchingDonors.content[i]  = this.props.response.patient.saveMatchingDonorResponse.matchingDonor;
        this.props.response.patient.matchingDonors = tempMatchingDonors;
      }
    }    
    else if(this.props.response.donor.noServiceResponse){
      this.state.modalOKEnabled = true;
      message = 'Sairam! Sorry. We are not able to process your request. Please try later.'
    }
    
    if(this.props.response.patient && this.props.response.patient.matchingDonors){
      totalPages = this.props.response.patient.matchingDonors.totalPages;
      currentPage = this.props.response.patient.matchingDonors.number;
    }
    
    let patientRequest = this.props.response.patient;

    return (      
      <Formik
        initialValues={{
          adminComments: '',
          status: ''
        }}        
        onSubmit={fields => {
          let id = this.state.reqId;
          let status = fields.status;
          let adminComments = fields.adminComments;
          let token = this.props.response.login.userToken; 
          const updateStatusPayload = {
            id,status,adminComments,token
          };

          if(this.props.response.donor.response !== 'undefined')
            delete this.props.response.donor.response;

          if(this.props.response.donor.addVolunteerDonor !== 'undefined')
            delete this.props.response.donor.addVolunteerDonor;

          if(this.props.response.donor.deleteVolunteerDonor !== 'undefined')
            delete this.props.response.donor.deleteVolunteerDonor;
          
          if(this.props.response.patient.matchDonor !== 'undefined')
            delete this.props.response.patient.matchDonor;  

          if(this.props.response.donor.addActualDonor !== 'undefined')
            delete this.props.response.donor.addActualDonor;

          if(this.props.response.patient.saveMatchingDonorResponse !== 'undefined')
            delete this.props.response.patient.saveMatchingDonorResponse;

          this.state.actualDonorId = '';
          this.state.actualDonorDate = '';
                          
          this.state.updateStatusClicked = true;        
          
          if (this.props.response.login.isSignedIn) {
            this.handleShow();
            this.props.dispatch(updatePatientAction(updateStatusPayload));  
          }
      }
    }
        render={({ handleSubmit, errors, status, touched }) => (                    
          <div className="wrapper">            
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
            <Container>
              <Card>
                <CardBody align="center" tag="h6">Patient Details</CardBody>
              </Card>
                      <TableContainer component={Paper}>
                <Table className="table" size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">Update</TableCell>
                      <TableCell align="right">Status</TableCell>
                      <TableCell align="right">Patient Name</TableCell>
                      <TableCell align="right">Attender</TableCell>
                      <TableCell align="right">Phone</TableCell>                      
                      <TableCell align="right">Blood&nbsp;Group</TableCell>          
                      <TableCell align="right">Units</TableCell>
                      <TableCell align="right">Required By</TableCell>
                      <TableCell align="right">Hospital</TableCell>      
                      <TableCell align="right">Age</TableCell>
                      <TableCell align="right">Gender</TableCell>                      
                      <TableCell align="right">Locality(appx.)</TableCell>
                      <TableCell align="right">District</TableCell>
                      <TableCell align="right">PinCode</TableCell>
                      <TableCell align="right">Purpose</TableCell>
                      <TableCell align="right">Last modified by</TableCell>
                      <TableCell align="right">Last modified at</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                      <TableRow>
                        <TableCell align="right">
                          <Button size="sm" onClick={() => this.handleUpdateRequestClick()} className="btn btn-primary btn-icon btn-round">
                            <i className="now-ui-icons ui-1_settings-gear-63 mr-1"></i>
                          </Button>
                        </TableCell>
                        <TableCell align="right">{patientRequest.status}</TableCell>
                        <TableCell align="right">{patientRequest.fullname}</TableCell>
                        <TableCell align="right">{patientRequest.attender}</TableCell>
                        <TableCell align="right">{patientRequest.phone}</TableCell>
                        <TableCell align="right">{patientRequest.bloodGroup}</TableCell>              
                        <TableCell align="right">{patientRequest.units}</TableCell>              
                        <TableCell align="right">{patientRequest.requiredBy}</TableCell>              
                        <TableCell align="right">{patientRequest.hospitalName + " " + patientRequest.hospital}</TableCell>                                                              
                        <TableCell align="right">{patientRequest.age}</TableCell>
                        <TableCell align="right">{patientRequest.gender}</TableCell>
                        <TableCell align="right">{patientRequest.locality}</TableCell>
                        <TableCell align="right">{patientRequest.district}</TableCell>
                        <TableCell align="right">{patientRequest.pincode}</TableCell>
                        <TableCell align="right">{patientRequest.purpose}</TableCell>
                        <TableCell align="right">{patientRequest.lastModifiedBy}</TableCell>
                        <TableCell align="right">{moment(patientRequest.lastModifiedAt).format('DD-MM-YYYY HH:mm')}</TableCell>
                      </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <br/>
              <Card>
                <CardBody align="center" tag="h6">Volunteer Donors</CardBody>
              </Card>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">Update</TableCell>
                      <TableCell align="right">Donor Name</TableCell>
                      {/*<TableCell align="right">Donor Notes</TableCell>*/}
                      <TableCell align="right">Phone</TableCell>
                      {/*<TableCell align="right">Preferred Day</TableCell>*/}  
                      <TableCell align="right">Blood&nbsp;Group</TableCell>                                                 
                      {/*<TableCell align="right">Last Donated</TableCell>*/}
                      {/*<TableCell align="right">DOB</TableCell>*/}
                      <TableCell align="right">Gender</TableCell>
                      <TableCell align="right">Email</TableCell>
                      <TableCell align="right">District</TableCell>
                      <TableCell align="right">PinCode</TableCell>
                      {/*<TableCell align="right">Height</TableCell>*/}
                      {/*<TableCell align="right">Weight</TableCell>*/} 
                      <TableCell align="right">Add Actual Donor</TableCell>
                      <TableCell align="right">Delete</TableCell>                                           
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {patientRequest.volunteerDonors ? patientRequest.volunteerDonors.map((row) => (
                      <TableRow key={row.id}>
                          <TableCell align="right">
                            <Button size="sm" onClick={() => this.handleDonorClick(row.phone)} className="btn btn-primary btn-icon btn-round">
                              <i className="now-ui-icons ui-1_settings-gear-63 mr-1"></i>
                            </Button>
                          </TableCell>
                        <TableCell align="right">{row.fullname}</TableCell>
                        {/*<TableCell align="right">{row.notes}</TableCell>*/}
                        <TableCell align="right">{row.phone}</TableCell>
                        {/*<TableCell align="right">{row.dayPreference}</TableCell>*/}
                        <TableCell align="right">{row.bloodGroup}</TableCell>
                        {/*<TableCell align="right">{row.lastDonatedOn}</TableCell>*/}              
                        {/*<TableCell align="right">{row.dateOfBirth}</TableCell>*/}
                        <TableCell align="right">{row.gender}</TableCell>
                        <TableCell align="right">{row.email}</TableCell>
                        <TableCell align="right">{row.district}</TableCell>
                        <TableCell align="right">{row.pincode}</TableCell>
                        {/*<TableCell align="right">{row.height}</TableCell>*/}
                        {/*<TableCell align="right">{row.weight}</TableCell>*/}
                        <TableCell align="right">
                            <Button size="sm" onClick={() => this.handleAddActualDonor(row.id)} className="btn btn-primary btn-icon btn-round">
                              <i className="now-ui-icons ui-1_simple-add mr-1"></i>
                            </Button>
                          </TableCell>
                        <TableCell align="right">
                            <Button size="sm" onClick={() => this.deleteVolunteerDonor(row.id)} className="btn btn-primary btn-icon btn-round">
                              <i className="now-ui-icons ui-1_simple-remove mr-1"></i>
                            </Button>
                          </TableCell>
                      </TableRow>
                    )) : ''}
                  </TableBody>
                </Table>
              </TableContainer>
              <br/>
              <Card>
                <CardBody align="center" tag="h6">Actual Donors</CardBody>
              </Card>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">Donor Name</TableCell>
                      <TableCell align="right">Phone</TableCell> 
                      <TableCell align="right">Blood&nbsp;Group</TableCell>                                                 
                      <TableCell align="right">Last Donated</TableCell>
                      <TableCell align="right">DOB</TableCell>
                      <TableCell align="right">Gender</TableCell>
                      <TableCell align="right">Email</TableCell>
                      <TableCell align="right">District</TableCell>
                      <TableCell align="right">PinCode</TableCell>
                      {/*<TableCell align="right">Height</TableCell>*/}
                      {/*<TableCell align="right">Weight</TableCell>*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {patientRequest.actualDonors ? patientRequest.actualDonors.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell align="right">{row.fullname}</TableCell>
                        <TableCell align="right">{row.phone}</TableCell>                        
                        <TableCell align="right">{row.bloodGroup}</TableCell>              
                        <TableCell align="right">{row.lastDonatedOn}</TableCell>              
                        <TableCell align="right">{row.dateOfBirth}</TableCell>
                        <TableCell align="right">{row.gender}</TableCell>
                        <TableCell align="right">{row.email}</TableCell>
                        <TableCell align="right">{row.district}</TableCell>
                        <TableCell align="right">{row.pincode}</TableCell>
                        {/*<TableCell align="right">{row.height}</TableCell>*/}
                        {/*<TableCell align="right">{row.weight}</TableCell>*/}
                      </TableRow>
                    )) : ''}
                  </TableBody>
                </Table>
              </TableContainer><br/>
              <Form onKeyDown={this.onKeyDown}>

                <Modal
                centered
                show={this.state.show}
                onHide={this.handleClose}
                backdrop="static"
                keyboard={false}
                >
                    <Modal.Body>
                      {message ? message : 'Sairam! Processing your request.'}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                        OK
                      </Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                  centered
                  show={this.state.showNotes}
                  onHide={this.handleCloseNotes}
                  backdrop="static"
                  keyboard={false}
                  >
                    <Modal.Body>
                    <form>
                      Update Call Notes<br></br>
                      <input onChange={this.handleChangeNotes} name="notes" type="textarea" rows="3" value={this.state.notes}/>
                    </form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button type="submit" onClick={this.handleSaveNotes} className="btn btn-primary mr-2" variant="primary">
                        Save
                      </Button>
                      <Button className="btn btn-secondary mr-2" variant="secondary" onClick={this.handleCloseNotes}>
                        Cancel
                      </Button>
                    </Modal.Footer>
                </Modal>
                
                <Modal
                  centered
                  show={this.state.showActualDonor}
                  onHide={this.handleCloseActualDonor}
                  backdrop="static"
                  keyboard={false}
                  >
                    <Modal.Body>
                    <form>
                      Donated date<br></br>
                      <input onChange={this.handleChangeActualDonorDate} name="donorDate" type="date"/>
                    </form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button type="submit" onClick={this.saveActualDonor} className="btn btn-primary mr-2" variant="primary">
                        Save
                      </Button>
                      <Button className="btn btn-secondary mr-2" variant="secondary" onClick={this.handleCloseActualDonor}>
                        Cancel
                      </Button>
                    </Modal.Footer>
                </Modal>

                <Card>
                  <CardBody align="center" tag="h6">Matching Donors</CardBody>
                </Card>
                <div style={{color: "white"}}><h6>
                {
                    patientRequest && (patientRequest.status === 'Open' ||
                    patientRequest.status === 'Fulfilled-Closed' ||
                    patientRequest.status === 'Not Fulfilled-Closed') ?                
                    'Note:Request must be verified to view matching donors.'  : ''    
                }
                </h6></div><br></br>
                <div style={{color: "white"}}><h6> {this.state.districtFilter} district, {this.state.localityFilter} locality matching donors count: {patientRequest.matchingDonors ? patientRequest.matchingDonors.totalElements : ''}</h6></div>
              <UncontrolledDropdown className="btn-group" size="sm">
                <DropdownToggle
                  aria-expanded={false}
                  aria-haspopup={true}
                  caret
                  color="primary"
                  data-toggle="dropdown"
                  type="button"
                >
                  Size
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem active={this.state.resultSize === 5} href="5" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>5</DropdownItem>
                  <DropdownItem active={this.state.resultSize === 10} href="10" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>10</DropdownItem>
                  <DropdownItem active={this.state.resultSize === 15} href="15" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>15</DropdownItem>
                </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown className="btn-group" size="sm">
                  <DropdownToggle
                    aria-expanded={false}
                    aria-haspopup={true}
                    caret
                    color="primary"
                    data-toggle="dropdown"
                    type="button"
                  >
                    district
                  </DropdownToggle>
                  <DropdownMenu  style={{overflowY: 'scroll', maxHeight: "300px" }}>                    
                  {this.props.response.locality.response && this.props.response.locality.response.districts ? this.props.response.locality.response.districts.map((district) => (
                    <DropdownItem active={this.state.districtFilter === district} href={district} onClick={e => {e.preventDefault(); this.districtFilterChanged(e)}}>{district}</DropdownItem>
                    )) : ''}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <select onChange={e => {this.localityFilterChanged(e)}} id="localityFilter">
                  <option onClick={e => {this.localityFilterClicked(e)}} value="All">All</option>
                  {this.props.response.locality.response && this.props.response.locality.response.localities ? this.props.response.locality.response.localities.map((locality) => (
                    <option onClick={e => {this.localityFilterClicked(e)}} selected={this.state.localityFilter === locality} value={locality}>{locality}</option>
                    )) : ''}
                </select>&nbsp;&nbsp;
                                
                  <input name="name" type="text" onChange={this.handleChangeName} value={this.state.nameFilter} placeholder='donor name search' />
                  <button onClick={e => {e.preventDefault(); this.filterByName(e)}} className="btn btn-primary btn-icon btn-round">
                    <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
                  </button>                
                &nbsp;&nbsp;
                <Button size="sm"  onClick={() => this.handleRefresh(currentPage)} className="btn btn-primary btn-icon btn-round">
                    <i className="now-ui-icons loader_refresh"/>
                </Button>
                <TableContainer component={Paper}>                    
                  <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >{this.constructPaginationLinks(totalPages,currentPage)}</Pagination>                  
                  <Table size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                      <TableCell align="right">Update</TableCell>
                        <TableCell align="right">Update<br/>Call Notes</TableCell>
                        <TableCell align="right">
                          <Button size="sm" onClick={() => this.handleNotifyDonors(currentPage)} className="btn btn-primary btn-icon btn-round"><i className="now-ui-icons ui-1_send mr-1"></i></Button>
                        </TableCell>
                        <TableCell align="right">Volunteer</TableCell>                        
                        <TableCell align="right">Donor Name</TableCell>                        
                        <TableCell align="right">Phone</TableCell>
                        <TableCell align="right">Call Notes</TableCell>
                        <TableCell align="right">Other Info /<br/>Closure Notes</TableCell>
                        {/*<TableCell align="right">Preferred Day</TableCell>*/}
                        <TableCell align="right">Blood&nbsp;Group</TableCell>                                                 
                        <TableCell align="right">Last Donated On</TableCell>
                        {/*<TableCell align="right">Ailments</TableCell>*/}
                        {/*<TableCell align="right">DOB</TableCell>*/}
                        {/*<TableCell align="right">Gender</TableCell>*/}
                        {/*<TableCell align="right">Address</TableCell>*/}
                        {/*<TableCell align="right">District</TableCell>*/}
                        {/*<TableCell align="right">PinCode</TableCell>*/}
                        {/*<TableCell align="right">Height(cms)</TableCell>*/}
                        {/*<TableCell align="right">Weight(kgs)</TableCell>*/}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {patientRequest.matchingDonors ? patientRequest.matchingDonors.content.map((row, idx) => (
                        <TableRow key={row.id}>
                          <TableCell align="right">
                            <Button size="sm" onClick={() => this.handleDonorClick(row.phone)} className="btn btn-primary btn-icon btn-round">
                              <i className="now-ui-icons ui-1_settings-gear-63 mr-1"></i>
                            </Button>
                          </TableCell>
                          <TableCell align="right">
                            <Button onClick={() => this.handleShowNotes(idx,row.id)} className="btn btn-primary btn-icon btn-round">
                            <i className="now-ui-icons files_single-copy-04 mr-1"></i>
                            </Button>
                          </TableCell>
                          <TableCell align="right">

                          {this.populateStatus(row.id) === 0 ? <><i className="now-ui-icons loader_refresh spin"/></> : 
                            this.populateStatus(row.id) === 1 ? <><i className="now-ui-icons tech_mobile mr-1"/> <i className="now-ui-icons ui-1_email-85 mr-1"/></> : 
	                          this.populateStatus(row.id) === 2 ? <i className="now-ui-icons ui-1_email-85 mr-1"/> :
	                          this.populateStatus(row.id) === 3 ? 
                              <i className="now-ui-icons ui-1_simple-remove mr-1">
                                <Button size="sm" onClick={() => this.handleNotifyDonor(row, currentPage)} className="btn btn-primary btn-icon btn-round"><i className="now-ui-icons ui-1_send mr-1"></i></Button>
                              </i> :
                            this.populateStatus(row.id) === 4 ? 
                            <i className="now-ui-icons tech_mobile mr-1"/> :
                            <Button size="sm" onClick={() => this.handleNotifyDonor(row, currentPage)} className="btn btn-primary btn-icon btn-round"><i className="now-ui-icons ui-1_send mr-1"></i></Button>
                            }
                          </TableCell>
                          <TableCell align="right">
                            <Button size="sm" onClick={() => this.addVolunteerDonor(row.id)} className="btn btn-primary btn-icon btn-round">
                              <i className="now-ui-icons ui-2_like mr-1"></i>
                            </Button>
                          </TableCell>
                          <TableCell align="right">{row.fullname}</TableCell>
                          <TableCell align="right">{row.phone}</TableCell>
                          <TableCell align="right">{row.callNotes}</TableCell>                        
                          <TableCell align="right">{row.notes}</TableCell>
                          {/*<TableCell align="right">{row.dayPreference}</TableCell>*/}
                          <TableCell align="right">{row.bloodGroup}</TableCell>
                          <TableCell align="right">{row.lastDonatedOn}</TableCell>
                          {/*<TableCell align="right">{row.ailments ? row.ailments.join(' | ') : 'None'}</TableCell>                        
                          {/*<TableCell align="right">{row.dateOfBirth}</TableCell>*/}
                          {/*<TableCell align="right">{row.gender}</TableCell>*/}
                          {/*<TableCell align="right">{row.address}</TableCell>*/}
                          {/*<TableCell align="right">{row.district}</TableCell>*/}
                          {/*<TableCell align="right">{row.pincode}</TableCell>*/}
                          {/*<TableCell align="right">{row.height}</TableCell>*/}
                          {/*<TableCell align="right">{row.weight}</TableCell>*/}
                        </TableRow>
                      )) : 'No matching donors found'}
                    </TableBody>
                  </Table>
                  <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >{this.constructPaginationLinks(totalPages,currentPage)}</Pagination>
                </TableContainer>
                <br/>
                <Card>
                  <CardBody align="center" tag="h6">Search donor by phone</CardBody>
                </Card>                
                <TableContainer component={Paper}>
                                  
                <form>
                  <input onChange={this.handleChangePhone} name="phone" type="text" />
                  <button onClick={e => {e.preventDefault(); this.matchingDonorByPhone(e)}} className="btn btn-primary btn-icon btn-round">
                    <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
                  </button>                        
                </form>
                  
                                 
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                        <TableCell align="right">Volunteer</TableCell>
                        <TableCell align="right">Donor Name</TableCell>
                        <TableCell align="right">Phone</TableCell> 
                        <TableCell align="right">Blood&nbsp;Group</TableCell>
                        <TableCell align="right">Last Donated</TableCell>
                        <TableCell align="right">Ailments</TableCell>                      
                        <TableCell align="right">DOB</TableCell>
                        <TableCell align="right">Gender</TableCell>
                        <TableCell align="right">Address</TableCell>
                        <TableCell align="right">District</TableCell>
                        <TableCell align="right">PinCode</TableCell>
                        <TableCell align="right">Height(cms)</TableCell>
                        <TableCell align="right">Weight(kgs)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.props.response.patient.matchDonor ? 
                      <TableRow>
                        <TableCell align="right">
                          <Button size="sm" onClick={() => this.addVolunteerDonor(this.props.response.patient.matchDonor.id)} className="btn btn-primary btn-icon btn-round">
                              <i className="now-ui-icons ui-2_like mr-1"></i>
                          </Button>
                        </TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.fullname}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.phone}</TableCell>                        
                        <TableCell align="right">{this.props.response.patient.matchDonor.bloodGroup}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.lastDonatedOn}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.ailments ? this.props.response.patient.matchDonor.ailments.join(' | ') : 'None'}</TableCell>                        
                        <TableCell align="right">{this.props.response.patient.matchDonor.dateOfBirth}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.gender}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.address}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.district}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.pincode}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.height}</TableCell>
                        <TableCell align="right">{this.props.response.patient.matchDonor.weight}</TableCell>
                      </TableRow>
                      : ''}
                  </TableBody>
                </Table>
              </TableContainer><br/>
                <div style={{color: "white"}}>Status</div>                            
                <Field 
                className="no-border input-lg  input-group-focus"
                name="status" id="status" component="select">
                  <option></option>
                  <option>Fulfilled-Closed</option>
                  <option>Partially Fulfilled-Closed</option>                                
                  <option>Unknown donor-Closed</option>
                  <option>Not Fulfilled-Closed</option>
                  <option>Cancelled-Closed</option>
                </Field><br/><br/>                          
                <div style={{color: "white"}}>Comments
                <Field name="adminComments" type="textarea" className={'form-control'} style={{backgroundColor: 'white'}}/></div>
                <br/>
                <div style={{color: "white"}}>Feedback
                <input disabled name="feedback" type="textarea" value={patientRequest.feedback} className={'form-control'} /></div>
                <br/>
                <div style={{color: "white"}}>Request Notes
                <input disabled name="notes" type="textarea" value={patientRequest.notes} className={'form-control'} /></div>
                <br/>
                <div style={{color: "white"}}>Comments history
                <button id="toggler" className="btn btn-primary btn-icon btn-round">
                  <i className="now-ui-icons arrows-1_minimal-down"></i>
                </button></div>
                <UncontrolledCollapse toggler="#toggler">
                  <div>
                    <TableContainer component={Paper}>
                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">By</TableCell>
                            <TableCell align="left">Time</TableCell> 
                            <TableCell align="left">Comments</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {patientRequest.auditTrail ? patientRequest.auditTrail.map((row) => (
                            <TableRow key={row.id}>
                              <TableCell align="left">{row.createdBy}</TableCell>
                              <TableCell align="left">{moment(row.createTimestamp).format('DD-MM-YYYY HH:mm')}</TableCell>                        
                              <TableCell align="left">{row.notes}</TableCell>
                            </TableRow>
                          )) : 
                            <TableRow>
                              <TableCell align="left">None</TableCell>
                              <TableCell align="left">None</TableCell>                        
                              <TableCell align="left">None</TableCell>
                            </TableRow>
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <br></br>
                  </div>
                </UncontrolledCollapse>
                <div className="form-group">
                    {patientRequest && patientRequest.status === 'Open' ? 
                      <Button className="btn btn-sm btn-primary mr-2" onClick={() => this.handleVerifyClick()}>Verify</Button>
                    : '' }  
                    <button type="button" onClick={handleSubmit} className="btn btn-sm btn-primary mr-2">Update Status</button>
                    <button type="reset" className="btn btn-sm btn-secondary">Reset</button>
                    <Button className="btn btn-sm btn-primary mr-2" onClick={() => this.handleBackClick()}>Go to requests</Button>  
                </div>                        
              </Form>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return <PatientRequestDetails navigate={navigate} location={location} {...props} />
});